import { COMBOS_PATH } from "../../functions/src/admin/paths";
import { useDatabaseVal } from "./firebaseHooks";
import type { Combo, Combos } from "../../functions/src/types";

/**
 * Hook to get combo mode from the new database structure
 */
export function useComboMode(isStaff: boolean): number | undefined {
    return useComboData(isStaff)?.mode ?? undefined;
}

/**
 * Hook to get combo data from the new database structure
 */
export function useComboData(isStaff: boolean): Combo | undefined {
    const comboType = isStaff ? 'personnelCombo' : 'studentCombo';
    const combosData = useCombosData();
    return combosData?.[comboType];
}

/**
 * Hook to get all combos data from the new database structure
 */
export function useCombosData(): Combos | undefined {
    const [combosData] = useDatabaseVal<Combos>(COMBOS_PATH);
    return combosData;
} 